<template>
  <div>
    <van-form
      validate-first
      @failed="onFailed"
      @submit="submit"
      v-if="resStatus == 0"
      ref="form"
    >
      <van-panel title="基本信息" status="编辑">
        <van-field
          name="sex"
          label="性别"
          :required="true"
          :rules="[{ required: true, message: '性别必填' }]"
        >
          <template #input>
            <van-radio-group v-model="formData['sex']" direction="horizontal">
              <van-radio name="男">男</van-radio>
              <van-radio name="女">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- 通过 pattern 进行正则校验 -->
        <van-field
          label="姓名"
          v-model="formData.name"
          name="name"
          placeholder="请输入姓名"
          maxlength="10"
          :rules="[
            { required: true, message: '姓名2~10个字符', pattern: /.{2,10}/ }
          ]"
          :required="true"
        />

        <van-field
          :required="true"
          readonly
          clickable
          label="学历"
          :value="formData['xueli']"
          name="xueli"
          placeholder="选择学历"
          @click="showPicker = true"
          :rules="[{ required: true, message: '请选择学历' }]"
        />
        <van-field name="work_year" label="工作年限" :required="true">
          <template #input>
            <van-stepper
              v-model="formData['work_year']"
              min="1"
              max="60"
              integer
            />
          </template>
        </van-field>
        <van-field
          label="身份证号"
          :required="true"
          readonly
          clickable
          name="card_num"
          :value="formData['card_num']"
          @touchstart.native.stop="cardNumsSow = true"
          placeholder="请输入身份证号"
          :rules="[
            {
              required: true,
              message: '请输入正确身份证号',
              pattern: regCardNum
            }
          ]"
        />
        <van-field
          :required="true"
          label="工作单位"
          v-model="formData['work_unit']"
          name="work_unit"
          placeholder="请输入工作单位"
          maxlength="30"
          :rules="[
            {
              required: true,
              message: '工作单位5~30个字符',
              pattern: /.{5,30}/
            }
          ]"
        />
        <van-field
          :required="true"
          label="联系地址"
          v-model="formData['address']"
          name="address"
          placeholder="请输入联系地址"
          maxlength="50"
          :rules="[
            {
              required: true,
              message: '工作单位5~30个字符',
              pattern: /.{5,50}/
            }
          ]"
        />
        <van-field
          :required="true"
          v-model="formData['mobile']"
          type="tel"
          name="mobile"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[
            {
              required: true,
              message: '请输入正确手机号',
              pattern: /^1[3456789]\d{9}$/
            }
          ]"
        />
        <van-field
          name="photo"
          label="二寸近期免冠照片"
          :required="true"
          :rules="[{ required: true, message: '请上传二寸近期免冠照片' }]"
        >
          <template #input>
            <uploader
              upload-text="免冠照片"
              name="photo"
              :after-read="afterRead"
              :max-count="1"
              :before-read="beforeRead"
              v-model="imgList['photo']"
            />
            尺寸：626*413
          </template>
        </van-field>
        <van-field
          name="card_front"
          label="身份证"
          :required="true"
          :rules="[{ required: true, message: '请上传身份证照片' }]"
        >
          <template #input>
            <uploader
              upload-text="身份证正面照"
              name="card_front"
              :after-read="afterRead"
              :max-count="1"
              :before-read="beforeRead"
              v-model="imgList['card_front']"
            />
            <uploader
              upload-text="身份证反面照"
              name="card_back"
              :after-read="afterRead"
              :max-count="1"
              :before-read="beforeRead"
              v-model="imgList['card_back']"
            />
          </template>
        </van-field>

        <van-field
          v-model="formData['working']"
          show-word-limit
          name="working"
          rows="3"
          autosize
          label="从业经历"
          type="textarea"
          maxlength="255"
          placeholder="请输入从业经历"
        />
      </van-panel>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-number-keyboard
        :show="cardNumsSow"
        v-model="formData['card_num']"
        extra-key="X"
        :maxlength="18"
        close-button-text="完成"
        @blur="cardNumsSow = false"
      />
    </van-form>

    <van-empty
      class="custom-image"
      description="长按识别二维码，联系工作人员审核"
      :image="
        '//aijiutang.oss-cn-beijing.aliyuncs.com/static_img/chuangye-kf.jpg?v=' +
          Math.random()
      "
      v-else-if="resStatus == 1"
    >
      <van-button round type="primary" class="bottom-button" @click="goBack">
        我要返回
      </van-button>
      <van-button
        round
        type="default"
        class="bottom-button edit-btn"
        @click="getInfo"
      >
        继续编辑
      </van-button>
    </van-empty>

    <van-empty description="很遗憾！发表失败" v-else-if="resStatus == -1">
      <van-button
        round
        type="danger"
        :loading="loading"
        class="bottom-button"
        @click="goBack"
      >
        我要返回
      </van-button>
      <van-button
        round
        type="default"
        class="bottom-button edit-btn"
        @click="getInfo"
      >
        继续编辑
      </van-button>
    </van-empty>
  </div>
</template>

<script>
import {
  Form as vanForm,
  Uploader,
  Picker as VanPicker,
  Stepper as VanStepper,
  NumberKeyboard as VanNumberKeyboard,
  Popup as VanPopup,
  RadioGroup as VanRadioGroup,
  Radio as VanRadio,
  Panel as VanPanel,
  Empty as vanEmpty,
  Toast,
  Field as vanField,
  Button as vanButton
} from "vant";
import getToken, { upload } from "@api/aliyun";
import { getAuthInfo, submitAuthInfo } from "@api/user";
let imgKeys = {
  photo: "免冠照片",
  card_front: "身份证正面照",
  card_back: "身份证反面照"
};
export default {
  name: "info",
  components: {
    Uploader,
    vanForm,
    vanField,
    vanButton,
    vanEmpty,
    VanPanel,
    VanRadioGroup,
    VanRadio,
    VanPicker,
    VanPopup,
    VanStepper,
    VanNumberKeyboard
  },
  data() {
    return {
      cardNumsSow: false,
      columns: ["无", "小学", "初中", "高中", "大专", "本科", "研究生及以上"],
      showPicker: false,
      userInfo: {},
      formData: {
        id: 0,
        address: "",
        card_back: "",
        card_copy: "",
        card_front: "",
        card_num: "",
        mobile: "",
        name: "",
        photo: "",
        sex: "",
        work_unit: "",
        work_year: 1,
        working: "",
        xueli: ""
      },
      imgList: {
        photo: [],
        card_front: [],
        card_back: []
      },
      resStatus: 0,
      upDir: "ajs_auth",
      regCardNum: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
      patternTitle: /.{3,50}/,
      loading: false
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    validator(val) {
      return /1\d{10}/.test(val);
    },
    // 异步校验函数返回 Promise
    asyncValidator(val) {
      return new Promise(resolve => {
        Toast.loading("验证中...");

        setTimeout(() => {
          Toast.clear();
          resolve(/\d{6}/.test(val));
        }, 1000);
      });
    },
    onConfirm(value) {
      this.formData["xueli"] = value;
      this.showPicker = false;
    },
    onFailed({ errors, values }) {
      console.log("onFailed-values", values);
      Toast.fail(errors[0].message);
    },
    onEditorBlur(editor) {
      console.log("editor blur!", editor);
    },
    onEditorFocus(editor) {
      console.log("editor focus!", editor);
    },
    onEditorReady(editor) {
      console.log("editor ready!", editor);
    },
    getRandonName() {
      return new Date().getTime() + parseInt(Math.random() * 100000);
    },
    async submit() {
      for (let key in imgKeys) {
        if (!this.imgList[key]) {
          Toast(`请上传 ${imgKeys[key]}`);
          return;
        }
      }

      if (this.loading) return;
      this.loading = true;
      Toast.loading("验证中...");
      await this.upToOss().then(r => {
        console.log("upToOss-back", r);
      });
      submitAuthInfo(this.formData)
        .then(r => {
          console.log(r);
          Toast.success("上传成功");
          this.formData = {
            title: "",
            imgs: [],
            content: ""
          };
          this.imgList = [];
          this.resStatus = 1;
        })
        .catch(err => {
          Toast.fail(err);
          this.resStatus = -1;
        })
        .finally(() => {
          Toast.clear();
          this.loading = false;
        });
    },
    upToOss() {
      return new Promise((resolve, reject) => {
        console.log("准备上传-1");
        // 发送阿里云
        getToken({ updir: this.upDir })
          .then(async r => {
            let data = r.data;
            for (let k in this.imgList) {
              let item = this.imgList[k][0];

              if (item["key"]) {
                let { file, key } = item;

                let fData = new FormData();
                for (let kd in data) {
                  fData.append(kd, data[kd]);
                }
                fData.append("key", key);
                fData.append("file", file);
                item.status = "uploading";
                item.message = "上传中...";

                await upload(data.host, fData)
                  .then(res => {
                    console.log("上传成功res", res);
                    this.formData[k] = data["host"] + "/" + key;
                    item.status = "done";
                    item.message = "上传成功";
                  })
                  .catch(err => {
                    console.log("上传失败-imgList-3", err);
                  });
              } else if (item["url"]) {
                this.formData[k] = item["url"];
              }
            }
            console.log("上传完成返回");
            return resolve(true);
          })
          .catch(err => {
            console.log("错误上传", err);
            return reject(false);
          });
      });
    },
    getInfo() {
      getAuthInfo()
        .then(r => {
          if (!r.data) return;
          this.formData = { ...this.formData, ...r.data };
          for (let k in imgKeys) {
            if (!r.data[k]) continue;
            this.imgList[k] = [{ url: r.data[k] }];
          }
          this.resStatus = 0;
        })
        .catch(err => {
          Toast.fail(err);
          this.$router.go(-1);
        });
    },
    // upload
    beforeRead(file, { name }) {
      // 上传之前检测图片类似返回true和false会影响到onRead函数
      // console.log("beforeRead-file", file);
      let regex = /(.jpg|.jpeg|.png|.bmp)$/;
      if (!regex.test(file.type)) {
        Toast(
          `图片格式不支持上传${JSON.stringify(file)},${JSON.stringify(name)}`
        );
        return false;
      }

      return true;
    },
    afterRead(file, { name }) {
      let imgType = {
        "image/png": "png",
        "image/jpeg": "jpg",
        "image/gif": "gif"
      };
      imgType = imgType[file.file.type] || ""; // 图片类型
      let key =
        this.upDir + "/" + name + "/" + this.getRandonName() + "." + imgType;
      this.imgList[name][0]["key"] = key;
      if (file.file.size > 500 * 1024) {
        let img = new Image();
        img.src = file.content;
        img.onload = () => {
          let data = this.compress(img, 1);
          this.imgList[name][0]["file"] = this.dataURLtoFile(data);
        };
      }
      console.log("imgList", this.imgList);
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      let arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      });
    }
  }
};
</script>

<style scoped>
.edit-btn {
  margin-left: 0.5rem;
}
</style>
